/**
 * Clics en links acortados (Link Shortening, apagado por defecto). Twilio no separa un clic de
 * la vista previa que arma el teléfono (F15): la tarjeta lo dice siempre. «Únicos» = mensajes
 * distintos con al menos un clic.
 */

import type { ClicsCampana } from "../../types.estadisticas";
import { ACLARACION_CLICS, ACLARACION_LINKS } from "../../logic/estadisticas";
import { num } from "../../../campana-nueva/utils/format";

export function TarjetaClics({ clics }: { clics: Pick<ClicsCampana, "activo" | "total" | "unicos"> & Partial<Pick<ClicsCampana, "tasaClicPct" | "porLink">> }) {
  const tasa = clics.tasaClicPct;
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        <div className="rounded-xl bg-slate-50 px-3 py-2.5">
          <p className="text-lg font-semibold text-slate-900">{num(clics.total)}</p>
          <p className="text-xs text-slate-600">Clics</p>
        </div>
        <div className="rounded-xl bg-slate-50 px-3 py-2.5">
          <p className="text-lg font-semibold text-slate-900">{num(clics.unicos)}</p>
          <p className="text-xs text-slate-600">Mensajes con al menos un clic</p>
        </div>
        {tasa !== undefined && (
          <div className="rounded-xl bg-slate-50 px-3 py-2.5">
            <p className="text-lg font-semibold text-slate-900">{tasa === null ? "—" : `${(Math.round(tasa * 10) / 10).toLocaleString("es-AR")} %`}</p>
            <p className="text-xs text-slate-600">De los entregados</p>
          </div>
        )}
      </div>
      {!!clics.porLink?.length && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[11px] font-bold uppercase tracking-wider text-slate-400">
                <th scope="col" className="py-2 pr-3">Link</th>
                <th scope="col" className="py-2 pr-3 text-right">Clics</th>
                <th scope="col" className="py-2 text-right">Únicos</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {clics.porLink.map((l) => (
                <tr key={l.link}>
                  <td className="py-2 pr-3 text-slate-700 break-all">{l.link}</td>
                  <td className="py-2 pr-3 text-right tabular-nums text-slate-900">{num(l.clics)}</td>
                  <td className="py-2 text-right tabular-nums text-slate-700">{num(l.unicos)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="space-y-1 text-xs text-slate-400 leading-relaxed">
        <p>{ACLARACION_LINKS}</p>
        <p>{ACLARACION_CLICS}</p>
      </div>
    </div>
  );
}

export default TarjetaClics;
